import PropTypes from 'prop-types';
import AnimatedButtonImpl from './animated-button.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import AnimatedButtonTypes from './types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Simple button with text and/or icon that can show animated background when needed.
 *
 * @class AnimatedButton
 * @name component
 * @memberof Mojito.Presentation.Components.AnimatedButton
 */

/**
 * AnimatedButton component prop types.
 *
 * @property {Function} [onClick = ()=>{}] - Callback triggered when the button is clicked.
 * @property {string} state - The current {@link Mojito.Presentation.Components.AnimatedButton.types.STATES|State} of the button.
 * @property {string} [class] - A string containing additional CSS class names for the button's root element.
 * @property {node} [children] - The content to be rendered within the button.
 * @property {Function} [onHoverChange = () => {}] - Callback triggered when the hover state changes.
 *
 * @memberof Mojito.Presentation.Components.AnimatedButton.component
 */
const propTypes = {
    onClick: PropTypes.func,
    state: PropTypes.oneOf(Object.values(AnimatedButtonTypes.STATES)).isRequired,
    class: PropTypes.string,
    children: PropTypes.node,
    onHoverChange: PropTypes.func,
};

const defaultProps = {
    onClick: noop,
    onHoverChange: noop,
};

export default UIView('AnimatedButton', AnimatedButtonImpl, propTypes, defaultProps);
